import dayjs from 'dayjs';
import { formatMoney } from '@mpc/common/src/features/BudgetDetailTable/renderers';

/** 日期格式化：空值 → '--' */
export const formatDate = (v?: string): string => (v ? dayjs(v).format('YYYY-MM-DD') : '--');

/** 金额格式化：空值 → '--'；输出 "1,234.56 人民币" */
export const formatMoneyAmount = (amount?: number | null): string =>
  formatMoney({ amount: amount ?? undefined, currency: 'rmb' });

/** 字符串数组 join：空 → '--' */
export const joinText = (list?: (string | undefined)[]): string =>
  list && list.length > 0 ? list.filter(Boolean).join('，') : '--';
